module.exports = __webpack_public_path__ + "static/media/failed-order.d34049ab.svg";